import { API } from '../../../../common/api/constants';

// ПОЛУЧИТЬ ВСЕ ПРЕДЛОЖЕНИЯ
export const GET_ALL_OFFERS = `${API}/offers`;

// ПОЛУЧИТЬ ВСЕ ПРЕДЛОЖЕНИЯ ПО ФИЛЬТРУ
export const GET_FILTER_OFFERS = `${API}/offers/filter`;

// Получить Предложения по ID Профиля (USER)
export const GET_ALL_OFFERS_BY_ID = `${API}/offer/profile/`;

// Получить Предложение по ID с привязкой к Профилю
export const GET_OFFER_BY_ID = `${API}/offer/{offer_id}/profile/{profile_id}`;

// Получить все Виды услуг
export const GET_TYPES = `${API}/request/service_types`;

// ОТФИЛЬТРОВАТЬ ЗАЯВКИ ПО ПАРАМЕТРАМ, ПЕРЕДАЕТСЯ МАССИВ ПАРАМЕТРОВ - GET
export const FILTER_REQUESTS = `${API}/requests`;

// ПОЛУЧТЬ ВСЕ ТС ПО ID ПРОФИЛЯ
export const GET_VEHICLES_BY_PROFILE_ID = `${API}/transport/vehicle/profile`;

//Добавить Предложение
export const CREATE_OFFER = '/offer/profile/{profile_id}';

// ПОЛНОТЕКСТОВЫЙ ПОИСК ПО ПРЕДЛОЖЕНИЯМ
export const SEARCH_OFFER = `${API}/offers/search`;

// ПОЛУЧИТЬ ПРЕДЛОЖЕНИЯ ПО ФИЛЬТРУ
export const GET_OFFERS_BY_FILTER = `${API}/offers/filter/{profile_id}`;

export const GET_ALL_USERS = `${API}/authorization/users`;

// Обновить предложение
export const UPDATE_OFFER = `${API}/offer/{offer_id}/profile/{profile_id}`;

// ПОЛУЧИТЬ КОЛИЧЕСТВО ЗАЯВОК ПО ТИПАМ
export const GET_OFFERS_COUNTS = `${API}/offer/profiles/{profile_id}/status_counts`
